<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <material-card
          color="primary"
          title="Crear usuario">
          <v-form>
            <v-container py-0>
              <v-layout
                class="pt-3"
                wrap>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    class="purple-input"
                    label="Usuario"/>
                </v-flex>
                <v-flex
                  xs12
                  md6>
                  <v-text-field
                    label="Contraseña"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6>
                  <v-text-field
                    label="Documento"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6>
                  <v-text-field
                    label="Nombre"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6>
                  <v-text-field
                    label="Apellido"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6>
                  <v-text-field
                    label="Correo"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6>
                  <v-select
                    label="rol"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  text-xs-right>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="primary"
                    round>Crear usuario</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
        <v-flex md12>
          <material-card
            color="primary"
            title="Lista de usuarios">
            <v-form>
              <user-profileList ref="UserProfileList"/>
            </v-form>
          </material-card>
        </v-flex>
      </v-flex>
      <v-flex
        xs12
        md4/>
    </v-layout>
  </v-container>
</template>
<script>
import UserProfileList from './userProfileList'
export default {
  components: {
    UserProfileList
  }
  //
}
</script>
